<div class="itsl-course-enrollment-course-info__container">
    {#if !isEnrollmentCompleted}
        <div class="itsl-course-enrollment-course-info__feedback-container">
            <Banner
                visible={!isEnrollmentEnabled}
                text={enrollmentFeedbackText}
                type={enrollmentFeedbackType}
                closable={false}
            />
        </div>
        <slot name="actions"></slot>
        <slot name="details"></slot>
    {/if}
    <Banner
        visible={isEnrollmentCompleted}
        text={enrollmentCompletedMessage}
        closable={false}
    />
</div>

<script>
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';

    export let isEnrollmentEnabled = true;
    export let enrollmentFeedbackText = '';
    export let enrollmentFeedbackType = 'info';
    export let isEnrollmentCompleted = false;
    export let enrollmentCompletedMessage = '';
</script>